.root {
    width: 100%;
    height: 100%;
    overflow-y: auto;
    padding: var(--mantine-spacing-lg) var(--mantine-spacing-md);
}

.card {
    max-width: var(--app-thread-width);
    margin: 0 auto;
    overflow: hidden;
}

.header {
    padding: var(--mantine-spacing-sm) var(--mantine-spacing-lg);
    background-color: var(--dib-surface);
    border-bottom: 1px solid var(--mantine-color-default-border);
}

.headerIcon {
    color: var(--mantine-color-dibblue-9);
    flex-shrink: 0;
}

.filterChips {
    max-width: var(--app-thread-width);
    margin: 0 auto var(--mantine-spacing-md);
    display: flex;
    flex-wrap: wrap;
    gap: var(--mantine-spacing-xs);
}

.chip {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    padding: 7px 14px;
    border-radius: 20px;
    border: 1px solid var(--mantine-color-gray-5);
    background-color: var(--mantine-color-body);
    font-size: var(--mantine-font-size-sm);
    font-weight: 400;
    line-height: 1.4;
    color: var(--mantine-color-dark-5);
    transition:
        background-color 0.12s ease,
        border-color 0.12s ease,
        color 0.12s ease;
}

.chip:hover {
    background-color: var(--dib-surface);
}

/* Active filter is filled solid brand-blue with white text, per the v4
   prototype. */
.chipActive,
.chipActive:hover {
    border-color: var(--mantine-color-dibblue-9);
    background-color: var(--mantine-color-dibblue-9);
    color: var(--mantine-color-white);
    font-weight: 600;
}

.chipCount {
    font-size: var(--mantine-font-size-xs);
    font-weight: 500;
    line-height: 1;
    opacity: 0.5;
}

.chipActive .chipCount {
    color: var(--mantine-color-white);
    opacity: 0.85;
}

.results {
    display: flex;
    flex-direction: column;
    gap: 0;
    min-width: 0;
    padding: var(--mantine-spacing-md);
}

.resultsForLabel {
    line-height: 1.3;
}

.clamped {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: clip;
}

.resultCard {
    display: flex;
    align-items: center;
    gap: var(--mantine-spacing-sm);
    padding: var(--mantine-spacing-sm) var(--mantine-spacing-md);
    border: none;
    border-bottom: 1px solid var(--dib-surface);
    color: var(--mantine-color-dark-7);
    text-decoration: none;
    transition: padding-left 0.15s ease;
}

.resultCard:last-child {
    border-bottom: none;
}

.resultCard:hover,
.resultCard:focus,
.resultCard:visited {
    color: var(--mantine-color-dark-7);
    text-decoration: none;
}

.resultCard:hover {
    padding-left: calc(var(--mantine-spacing-md) + 4px);
}

.resultCard:hover .resultChevron {
    color: var(--dib-brand-base);
    transform: translateX(2px);
}

.resultBody {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 1px;
    overflow: hidden;
}

.resultTitle {
    font-size: var(--mantine-font-size-md);
    font-weight: 500;
    color: var(--mantine-color-dibblue-9);
    line-height: 1.35;
}

.typeBadge {
    flex-shrink: 0;
    font-size: var(--mantine-font-size-xs);
    font-weight: 400;
    color: var(--mantine-color-dark-5);
    padding: 4px 12px;
    border-radius: var(--mantine-radius-sm);
    border: 1px solid var(--mantine-color-gray-5);
    white-space: nowrap;
    line-height: 1.4;
}

.resultSub {
    font-size: var(--mantine-font-size-xs);
    line-height: 1.4;
    color: var(--mantine-color-gray-7);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.resultChevron {
    width: 14px;
    height: 14px;
    flex-shrink: 0;
    color: var(--mantine-color-gray-4);
    transition:
        color 0.15s ease,
        transform 0.15s ease;
}

.sidebarCol {
    display: flex;
    flex-direction: column;
    gap: var(--mantine-spacing-md);
}

.sidebar {
    display: flex;
    flex-direction: column;
    gap: var(--mantine-spacing-md);
    padding: var(--mantine-spacing-md);
    border: 1px solid var(--dib-surface);
    border-radius: 0;
}

.note {
    padding: var(--mantine-spacing-md);
    background-color: color-mix(in srgb, var(--dib-surface) 40%, transparent);
    border-radius: var(--mantine-radius-sm);
}

.mobileFilterBar {
    display: flex;
    justify-content: flex-end;
    margin-bottom: var(--mantine-spacing-sm);
}

.filterGroup {
    display: flex;
    flex-direction: column;
}

.filterGroupHeader {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 0 calc(var(--mantine-spacing-2xs) - 3px) var(--mantine-spacing-xs) 0;
}

.chevron {
    color: var(--mantine-color-default-color);
    transition: transform 200ms ease;
}

.chevronUp {
    transform: rotate(180deg);
}

.filterCount {
    font-size: var(--mantine-font-size-xs);
    font-weight: 500;
    line-height: 1;
}

/* Bigger design keeps the type pills; drop them on small screens where the
   row gets cramped. */
@media (max-width: 48em) {
    .typeBadge {
        display: none;
    }
}
